var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup"},[_c('span',[_vm._v("点击选择“添加到我的小程序”，就可以轻松购物啦~")]),_c('div',{staticClass:"close"},[_c('van-icon',{attrs:{"name":"clear","size":"16"},on:{"click":_vm.closeapplets}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }